import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Stock} from './stock';
import {ApiUtils} from '@shared/utils/api.utils';
import {StockEmail} from './stock-email';
import {ListFilter, ListResult, Pagination} from "@shared/base";
import {ConfigUtil} from '@shared/services/config.util';

@Injectable({
  providedIn: 'root'
})
export class StockApi {
  private readonly httpClient = inject(HttpClient);

  private readonly endpoint: string;

  constructor() {
    this.endpoint = `${ConfigUtil.get('api')['backend']}/stock`;
  }

  public findByAll(): Observable<Stock[]> {
    return this.httpClient.get<Stock[]>(`${this.endpoint}`);
  }

  public findById(id: number): Observable<Stock> {
    return this.httpClient.get<Stock>(`${this.endpoint}/${id}`).pipe(map(value => {
      return Object.assign(new Stock(), value);
    }));
  }

  public findByVrn(vrn: string): Observable<Stock> {
    return this.httpClient.get<Stock>(`${this.endpoint}/vehicle/${vrn}`).pipe(
      map(value => {
        if (value) {
          return Object.assign(new Stock(), value);
        } else {
          return null;
        }
      }));
  }

  public findByFilter(listFilter: ListFilter, pagination: Pagination): Observable<ListResult<Stock>> {
    const httpParams = ApiUtils.createHttpParams({...listFilter, ...pagination.toListFilter()});

    return this.httpClient.get<ListResult<Stock>>(`${this.endpoint}/search`, {params: httpParams}).pipe(map(value => {
      const result: ListResult<Stock> = Object.assign(new ListResult<Stock>(), value);

      result.data.forEach(stock => {
        const vehicle = stock.vehicle;

        if (vehicle.firstIssueDate) {
          vehicle.firstIssueDate = new Date(vehicle.firstIssueDate);
        }
        if (vehicle.firstAdmissionDate) {
          vehicle.firstAdmissionDate = new Date(vehicle.firstAdmissionDate);
        }
      });

      return result;
    }));
  }

  public update(stock: Stock): Observable<boolean> {
    return this.httpClient.put<boolean>(`${this.endpoint}/${stock.id}`, stock);
  }

  public report(type: string) {
    this.httpClient.get(`${this.endpoint}/report`, {
      responseType: 'blob',
      observe: 'response',
      params: {
        type: type
      },
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }).subscribe(response => {
      ApiUtils.saveToFileSystem(response);
    }, response => {
      console.error(response);
    });
  }

  public email(email: StockEmail) {
    return this.httpClient.post(`${this.endpoint}/mail`, email);
  }
}
